/**
 * @description 代码生成机状态管理
 */
import { getUploadParams, getImageUrl } from '@/api/upload'
import axios from 'axios'
import { uuid } from '@/utils'

const state = () => ({
  ossParams: {
    key: '', // key后面有用，先默认设空字符串
    success_action_status: '200' // 默认200
  }
})
const getters = {
  getOssParams: state => state.ossParams
}

const mutations = {
  setOssParams(state, ossParams) {
    state.ossParams = ossParams
  }
}
const actions = {
  async setOssParams({ commit, state }, param) {
    const { file } = param
    // console.log(file, 'setOssParams:::')
    // const filename = `${file.type.split('/').pop()}`
    // const { data } = await getUploadParams()
    // const p = {
    //   key: '', // key后面有用，先默认设空字符串
    //   success_action_status: '200' // 默认200
    // }
    // p.OSSAccessKeyId = data.accessid
    // p.key = data.dir + `${uuid(16)}.${filename}`
    // const params = {
    //   ...p,
    //   ...data,
    //   file
    // }
    const params = {
      file
    }
    commit('setOssParams', params)
  },
  async setUploadFile({ commit, state }) {
    var formData = new FormData()
    //注意formData里append添加的键的大小写
    // formData.append('policy', state.ossParams.policy) //policy
    // formData.append('signature', state.ossParams.signature) //签名
    // formData.append('key', state.ossParams.key) //存储在oss的文件路径
    // formData.append('ossaccessKeyId', state.ossParams.accessid) //accessKeyId
    // formData.append('dir', state.ossParams.dir) //policy
    // formData.append('host', state.ossParams.host) //
    formData.append('file', state.ossParams.file)
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        // url: state.ossParams.host,
        url: '/medical/health/BackArticle/uploadImage',
        data: formData
        // headers: {
        //   'Content-Type': 'multipart/form-data' //
        // }
      })
        .then(async response => {
          console.log(response, 'response')
          const params = {
            data: response.data.data
          }
          const { data } = await getImageUrl(params)
          console.log(data, 'url')
          // response.data = data
          resolve({ data: data })
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
export default { state, getters, mutations, actions }
